const ru = {
    "home.header.title": "Фильмы, сериалы и многое другое без ограничений",
    "home.header.subtitle": "Смотрите где угодно. Отменить подписку можно в любое время.",
    "home.header.cta": "Готовы смотреть? Введите адрес электронной почты, чтобы оформить или возобновить подписку.",
    "home.button.started":"Get Started",
    "home.main.tv": "Смотрите на телевизоре",
    "home.main.tvsubtitle":"Смотрите на Smart TV, PlayStation, Xbox, Chromecast, Apple TV, плеерах Blu-ray и других устройствах.",
    "home.main.phone":"Загружайте сериалы для просмотра офлайн",
    "home.main.phonesubtitle":"Сохраняйте видео в избранном, и у вас всегда будет, что посмотреть.",
    "home.main.lowertv":"Смотрите где угодно", 
    "home.main.lowertvsubtitles":"Смотрите фильмы и сериалы на телефоне, планшете, ноутбуке и телевизоре.",
    "home.main.kids":"Создавайте профили для детей",
    "home.main.kidssubtitle":"Подарите детям мир приключений с их любимыми героями. Он создан специально для них и уже доступен с вашей подпиской.",
    "home.footer.question":"Распространенные вопросы",
    
    "question1":"Что из себя представляет Netflix?",
    "answer1":
    `<h1>Netflix — это стриминговый сервис, позволяющий смотреть разнообразные
     удостоенные наград фильмы, сериалы, аниме, документальные фильмы и 
     многое другое на тысячах устройств с подключением к интернету.
     <br>
   <br>
   Вы можете смотреть сколько угодно и когда угодно без рекламы по фиксированной
   низкой цене за месяц. Вы всегда сможете найти что-нибудь новое — мы добавляем 
   сериалы и фильмы каждую неделю! </h1>`,

    "question2":"Сколько стоит Netflix?",
    "answer2":`<h1 >Смотрите Netflix на смартфоне, планшете, Smart TV,
     ноутбуке или телеприставке за единую фиксированную ежемесячную плату.
      Стоимость планов составляет от 9,39 EUR до 13,99 EUR в месяц. Никаких лишних
       расходов и обязательств.</h1>`,

     "question3":"Где смотреть?",
     "answer3":`<h1 >Смотрите где угодно, когда угодно. Войдите в свой аккаунт
      Netflix и смотрите через интернет на сайте netflix.com на персональном
       компьютере или любом устройстве с подключением к интернету и приложением 
       Netflix, включая телевизоры Smart TV, смартфоны, планшеты, плееры для 
       потокового видео и игровые консоли.
<br/>
<br/>
Также вы сможете загружать свои любимые сериалы через приложение для iOS, 
Android или Windows 10. Загружайте видео для просмотра в поездках без подключения
 к интернету. Возьмите с собой Netflix куда угодно.
</h1>`,

    "question4":"Как отменить подписку?",
    "answer4":`<h1>Netflix — гибкий сервис. Никаких запутанных контрактов и
    обязательств. Вы можете легко отменить подписку на сайте в два клика. 
    Никакой платы за отмену не взимается, открыть или закрыть аккаунт можно когда 
    угодно.</h1>`,

     "question5":"Что можно посмотреть на Netflix?",
     "answer5":`<h1>Netflix предлагает огромную библиотеку полнометражных фильмов,
      документальных фильмов, сериалов, аниме, удостоенного наград оригинального
       контента Netflix и многое другое. Смотрите сколько угодно и когда угодно.</h1>`,

      "question6":"Подходит ли контент Netflix для детей?",
      "answer6":`<h1>В подписку включен пакет Netflix Kids, который обеспечивает
       родителям необходимый контроль, а детям возможность получать удовольствие
        от просмотра фильмов и сериалов для всей семьи в своем собственном
         пространстве.
      <br/>
      <br/>
      Для детских профилей используется родительский контроль
       с использованием PIN-кода, который позволяет указать рейтинг контента,
        который могут смотреть дети, и заблокировать определенные видео, которые 
        вы не хотите, чтобы смотрели дети.
      </h1>`,

    "question7":"Этот язык выбран в настройках вашего браузера.",
    "answer7":`<h1>Этот язык выбран в настройках вашего браузера.</h1>`,

    "ready":"Готовы смотреть? Введите адрес электронной почты, чтобы оформить или возобновить подписку."
}
export default ru;